import { cn } from '@/utils/cn'
import type { ReactNode } from 'react'
import { Button } from '../common/button'
import { Card } from '../common/card'
import { CopySectionLink } from '../common/copySectionLink'
import { Dialog, DialogContent, DialogTrigger } from '../common/dialog'
import { ExpansionArrowsIcon } from '../icons/expansionArrows'

interface AnalyticsCardProps {
  id: string
  title: string
  description?: string
  footerLabel: string
  fullView: ReactNode
  dialogClassName?: string
  className?: string
  actions?: ReactNode
  children: ReactNode
}

export const AnalyticsCard = ({
  id,
  title,
  description,
  footerLabel,
  fullView,
  dialogClassName,
  className,
  actions,
  children,
}: AnalyticsCardProps) => {
  return (
    <section id={id} className={cn('group flex scroll-mt-4 flex-col', className)}>
      <Card className="flex h-fit flex-grow flex-col overflow-visible">
        <div className="rounded-t-2xl border-b bg-surface p-4 md:px-5 md:py-4">
          <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1">
            <div className="flex flex-col gap-0.5">
              <div className="flex items-center gap-2">
                <h3 className="font-semibold text-heading-foreground text-lg">{title}</h3>
                <CopySectionLink sectionId={id} />
              </div>
              {description && <p className="text-body-foreground text-sm">{description}</p>}
            </div>
            {actions}
          </div>
        </div>
        <div className="flex flex-grow flex-col p-4 pb-4 md:p-5 md:pb-5">{children}</div>
        <Dialog>
          <DialogTrigger asChild>
            <Button
              variant="input"
              size="default"
              className="h-12 w-full items-center justify-center gap-2 rounded-t-none rounded-b-2xl border-t bg-surface text-accent text-sm"
            >
              {footerLabel}
              <ExpansionArrowsIcon expanded={false} size={16} />
            </Button>
          </DialogTrigger>
          <DialogContent className={cn('max-w-5xl bg-page lg:max-h-[90vh]', dialogClassName)}>{fullView}</DialogContent>
        </Dialog>
      </Card>
    </section>
  )
}
